export default ({ request }) => ({
  sampleMetadataListApi(data = {}) {
    return request({
      url: "/master/sampleMetadata/list",
      method: "post",
      data,
    });
  },
  sampleMetadataSaveApi(data = {}) {
    return request({
      url: "/master/sampleMetadata/save",
      method: "post",
      data,
    });
  },
  sampleMetadataDetailApi(data = {}) {
    return request({
      url: "/master/sampleMetadata/detail",
      method: "post",
      data,
    });
  },
  sampleMetadataDelApi(data = {}) {
    return request({
      url: "/master/sampleMetadata/del",
      method: "post",
      data,
    });
  },
  sampleMetadataOptionsListApi(data = {}) {
    return request({
      url: "/master/sampleMetadataOptions/list",
      method: "post",
      data,
    });
  },
  sampleMetadataOptionsSaveApi(data = {}) {
    return request({
      url: "/master/sampleMetadataOptions/save",
      method: "post",
      data,
    });
  },
  sampleMetadataOptionsDetailApi(data = {}) {
    return request({
      url: "/master/sampleMetadataOptions/detail",
      method: "post",
      data,
    });
  },
  sampleMetadataOptionsDelApi(data = {}) {
    return request({
      url: "/master/sampleMetadataOptions/del",
      method: "post",
      data,
    });
  },
});
